// Generated by Melange

import * as Buhta_cabinet__TableSearchRow from "../../molecules/Table/TableSearchRow.js";
import * as Buhta_components__Text from "../../../../../../packages/components/src/html/Text.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(org) {
  return function (onNewProduct) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs(Buhta_cabinet__TableSearchRow.make, {
                        children: [
                          JsxRuntime.jsxs("button", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "w-4 h-4",
                                        src: StaticAsset.src("/static/icons/plus.svg")
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                                        className: "ml-1 text-white",
                                        children: "Товар или услуга"
                                      })
                                ],
                                className: "bg-links flex rounded px-3 py-2",
                                onClick: onNewProduct
                              }),
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "w-4 h-4",
                                        src: StaticAsset.src("/static/icons/xls-16.svg")
                                      }),
                                  JsxRuntime.jsx(Buhta_components__Text.H6.make, {
                                        className: "ml-1",
                                        children: "Загрузить таблицу"
                                      })
                                ],
                                className: "flex border border-gray-main rounded px-3 py-2"
                              })
                        ]
                      }),
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                className: "pl-6 py-3 border-b border-gray-main bg-gray-pale text-gray-medium",
                                children: "Артикул"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                className: "py-3 col-span-2 border-b border-gray-main bg-gray-pale text-gray-medium",
                                children: "Название"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                className: "py-3 border-b border-gray-main bg-gray-pale text-gray-medium",
                                children: "Ед. измерения"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                className: "py-3 border-b border-gray-main bg-gray-pale text-gray-medium",
                                children: "Налог"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                className: "py-3 border-b border-gray-main bg-gray-pale col-span-2 pr-6 text-right text-gray-medium",
                                children: "Цена"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Картошка"
                                    }),
                                className: "py-2.5 col-span-2 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276224"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Огурцы"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Яблоки"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Груши"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Абрикос"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Бананы"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Гранат"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Гуарана"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Авокадо"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Капуста"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "276225"
                                    }),
                                className: "pl-6 py-2.5 border-b border-gray-main"
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      children: "Лук"
                                    }),
                                className: "py-2.5 border-b border-gray-main col-span-2"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "Кг"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main",
                                children: "с НДС"
                              }),
                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                className: "py-2.5 border-b border-gray-main col-span-2 pr-6 text-right",
                                children: "1 600"
                              })
                        ],
                        className: "grid grid-cols-7 border-b border-gray-main"
                      })
                ],
                className: "flex flex-col w-full"
              });
  };
}

function ManageProducts(Props) {
  return make(Props.org)(Props.onNewProduct);
}

const make$1 = ManageProducts;

export {
  make$1 as make,
}
/* Buhta_cabinet__TableSearchRow Not a pure module */
